var dynamicRequire = require('../../dynamicRequire');
var React = dynamicRequire('react');
var AccordionTab = dynamicRequire('AccordionTab.jsx');
var resolveLanguage = dynamicRequire('resolveLanguage');
var Mssg = dynamicRequire('Mssg.jsx');
var SVGIcon = dynamicRequire('SVGIcon.jsx');

class Parts extends React.Component {

    render() {
        return <AccordionTab name={this.props.event} group='caseconfigurator'><strong
            className="lr-sidebar-accordion-block-title headline"><Mssg __key={this.props.title} /><SVGIcon identifier={'plus'}/><SVGIcon identifier={'minus'}/></strong>
            <div className="lr-casefactory-choices-part-picker part-picker">
                {this.props.parts.sort((part1, part2) => {/* not sure why the are not always sorted...*/return part1.id>part2.id?1:-1}).map((part, index) => {
                    var image = this.props.basePath + '/images/partImages/small/' + part.articleNumber + '.jpg'
                    var label = part.partName ? part.partName : resolveLanguage('nc_casefactory.part.name.' + part.articleNumber);
                    var description = part.description ? part.description : resolveLanguage('nc_casefactory.part.description.' + part.articleNumber);

                    return <div className="lr-casefactory-choices-part-picker-part part" key={part.id}>
                        <label className="lr-casefactory-choices-part-picker-part-name name">
                            <input
                                // check also the first item if no corner id is set b/c stackable cases do not have corners set, despite having corners option....
                                checked={this.props.id == part.id || this.props.id===null && index==0}
                                onChange={(e) => this.context.emitter.emit(this.props.event, part, e.target.value)}
                                value={part.id}
                                type="radio"
                                name={part.category}
                                className="lr-casefactory-choices-part-picker-part-input input"/>
                            <span className="lr-casefactory-choices-part-picker-part-text-label text-label" dangerouslySetInnerHTML={{__html: label}} />
                        </label>
                        <label className="lr-casefactory-choices-part-picker-part-image-label image-label">
                            <img src={image}
                                 className="lr-casefactory-choices-part-picker-part-image image"/>
                        </label>

                        <p className="lr-casefactory-choices-part-picker-part-description description" dangerouslySetInnerHTML={{__html: description}}/>
                    </div>
                })}
            </div>
        </AccordionTab>
    }
}

Parts.contextTypes = {
    emitter: React.PropTypes.object.isRequired,
};


module.exports = Parts;


// WEBPACK FOOTER //
// ./js/caseconfigurator-ui/lib/components/Options/Parts.jsx